module.exports = __webpack_public_path__ + "static/media/diwali_banner_finity.c1a3a357.svg";